import * as types from '../mutations-types'

// initial state
const state = {
  talentStroeData: {},
  roleData: {}
}

// actions
const actions = {}

// mutations
const mutations = {
  [types.SET_TANLENT_STROE_DATA](state, data) {
    state.talentStroeData = data
  },
  [types.SET_TALENT_ROLE_DATA](state, data) {
    state.roleData = data
  }
}
// getters
const getters = {}

export default {
  state,
  getters,
  actions,
  mutations
}
